"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var styled_components_1 = __importStar(require("styled-components"));
var components_1 = require("components");
var actions_1 = require("../actions/actions");
var EnvironmentSelect_1 = __importDefault(require("./EnvironmentSelect"));
var Gallery_1 = __importDefault(require("./Gallery"));
var ActionTypes_1 = require("../ActionTypes");
var ScreenshotManager_1 = require("../ScreenshotManager");
var GenericDialog_1 = __importDefault(require("./GenericDialog"));
var ShareDialog_1 = __importDefault(require("./ShareDialog"));
var utils_1 = require("../utils");
var libzl_1 = require("../libzl");
var react_intl_1 = require("react-intl");
var RestrictedIconButton = styled_components_1.default(components_1.IconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmax-width: 20vw;\n\tmax-height: 20vw;\n\toverflow: visible;\n\tbackground: none;\n\n\t&:hover, &:focus{\n\t\tbackground: #F0F0F0;\n\t}\n"], ["\n\tmax-width: 20vw;\n\tmax-height: 20vw;\n\toverflow: visible;\n\tbackground: none;\n\n\t&:hover, &:focus{\n\t\tbackground: #F0F0F0;\n\t}\n"])));
var CloseButton = styled_components_1.default(components_1.IconButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\toverflow: visible;\n\tbackground: none;\n\twidth: 60px;\n\theight: 60px;\n\tpadding-right: none;\n\t", ";\n"], ["\n\toverflow: visible;\n\tbackground: none;\n\twidth: 60px;\n\theight: 60px;\n\tpadding-right: none;\n\t", ";\n"])), function (props) { return props.theme.layout.exit; });
var NameWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tpadding-left: 30px;\n\tpadding-top: 20px;\n\tpadding-bottom: 6px;\n\n\t@media ", "{\n\t\tpadding-left: 11px;\n\t\tpadding-top: 8px;\n\t\tpadding-bottom: 0px;\n\t}\n\t\n"], ["\n\tpadding-left: 30px;\n\tpadding-top: 20px;\n\tpadding-bottom: 6px;\n\n\t@media ", "{\n\t\tpadding-left: 11px;\n\t\tpadding-top: 8px;\n\t\tpadding-bottom: 0px;\n\t}\n\t\n"])), function (props) { return props.theme.breakpoints.S; });
var CloseHolder = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t@media not ", " {\n\t\twidth: 108px;\n\t}\n\twidth: 100px;\n\tdisplay: inline-block;\n\ttext-align: center;\n"], ["\n\t@media not ", " {\n\t\twidth: 108px;\n\t}\n\twidth: 100px;\n\tdisplay: inline-block;\n\ttext-align: center;\n"])), function (props) { return props.theme.breakpoints.S; });
var Nameplate = styled_components_1.default(components_1.Lockup)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tline-height: 1;\n"], ["\n\tline-height: 1;\n"])));
var Swapbutton = styled_components_1.default(components_1.ChangeButton)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tpadding-left: 40px;\n\tpadding-bottom: 18px;\n\tvertical-align: bottom;\n\t@media ", " {\n\t\tdisplay: none;\n\t}\n"], ["\n\tpadding-left: 40px;\n\tpadding-bottom: 18px;\n\tvertical-align: bottom;\n\t@media ", " {\n\t\tdisplay: none;\n\t}\n"])), function (props) { return props.theme.breakpoints.S; });
var RoundButton = styled_components_1.default(RestrictedIconButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tborder-radius: 50%;\n\toutline:none;\n\tbackground-color: white;\n\tborder: 1px solid #F0F0F0;\n\twidth: 36px;\n\theight: 36px;\n\tpadding: 7px;\n\n\t&:hover, &:focus {\n\t\tfill: #E03C31;\n\t\tbackground-color: white;\n\t}\n\t", "\n"], ["\n\tborder-radius: 50%;\n\toutline:none;\n\tbackground-color: white;\n\tborder: 1px solid #F0F0F0;\n\twidth: 36px;\n\theight: 36px;\n\tpadding: 7px;\n\n\t&:hover, &:focus {\n\t\tfill: #E03C31;\n\t\tbackground-color: white;\n\t}\n\t", "\n"])), function (props) { return props.theme.menuButton; });
var StyledHeader = styled_components_1.default.header(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tbackground-color: white;\n\t", "\n"], ["\n\tbackground-color: white;\n\t", "\n"])), function (props) { return props.theme.layout.banner; });
var IconHolder = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\t\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tdisplay: none;\n\t}\n\tbackground: none;\n\n\talign-items: center;\n\tpadding-right: 25px;\n"], ["\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\t\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tdisplay: none;\n\t}\n\tbackground: none;\n\n\talign-items: center;\n\tpadding-right: 25px;\n"])), function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.M; });
var HeaderButts = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tdisplay: none;\n\t}\n"], ["\n\tdisplay: inline-block;\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tdisplay: none;\n\t}\n"])), function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.M; });
var MobileToggle = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\tdisplay: none;\n\tpadding-right: 11px;\n\n\t@media ", " {\n\t\tpadding-right: 30px;\n\t}\n\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tdisplay: inline;\n\t}\n"], ["\n\tdisplay: none;\n\tpadding-right: 11px;\n\n\t@media ", " {\n\t\tpadding-right: 30px;\n\t}\n\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tdisplay: inline;\n\t}\n"])), function (props) { return props.theme.breakpoints.M; }, function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.M; });
var Banner = /** @class */ (function (_super) {
    __extends(Banner, _super);
    function Banner(props) {
        var _this = _super.call(this, props) || this;
        _this.hideDialog = function () {
            _this.setState({ genericDialogParams: undefined });
        };
        _this.showDialog = function (unsavedMsg, savedMsg, exit, quote, closePath) {
            var info = "";
            var buttons = [];
            var linkButtons = [];
            if (_this.props.buildSession && _this.props.buildSession.hasUnsavedChanges() && !window.zlurlparams.global) {
                info = unsavedMsg;
                buttons.push({
                    label: _this.s("closeDialog.saveExit", "Save For Later"),
                    onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.props.buildSession.save()];
                                case 1:
                                    _a.sent();
                                    exit();
                                    this.hideDialog();
                                    return [2 /*return*/];
                            }
                        });
                    }); },
                    automationId: "saveexitbuild"
                });
                buttons.push({
                    label: _this.s("closeDialog.saveQuoteExit", "Save & Get Quote"),
                    onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.props.buildSession.save()];
                                case 1:
                                    _a.sent();
                                    quote();
                                    return [4 /*yield*/, this.props.buildSession.finished()];
                                case 2:
                                    _a.sent();
                                    this.hideDialog();
                                    actions_1.finalize();
                                    return [2 /*return*/];
                            }
                        });
                    }); },
                    automationId: "savequoteexitbuild"
                });
                linkButtons.push({
                    label: _this.s("closeDialog.exitNoSave", "Don't save this build"),
                    onClick: function () { exit(); _this.hideDialog(); },
                    automationId: "exitbuild"
                });
            }
            else {
                info = savedMsg;
                buttons.push({
                    label: _this.s("closeDialog.exit", "No, Thanks"),
                    onClick: function () { exit(); _this.hideDialog(); },
                    automationId: "returnbuild"
                });
                buttons.push({
                    label: _this.s("closeDialog.quoteExit", "Yes, Please"),
                    onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    quote();
                                    return [4 /*yield*/, this.props.buildSession.finished()];
                                case 1:
                                    _a.sent();
                                    this.hideDialog();
                                    actions_1.finalize();
                                    return [2 /*return*/];
                            }
                        });
                    }); },
                    automationId: "returnbuild"
                });
            }
            _this.setState({
                genericDialogParams: {
                    title: _this.s("closeDialog.exitConfigurator", "Wait!"),
                    info: info,
                    buttons: buttons,
                    linkButtons: linkButtons,
                    showClose: true,
                    onClose: _this.hideDialog
                }
            });
        };
        _this.showCloseDialog = function () {
            _this.showDialog(_this.s("closeDialog.unsavedMsg", "What do you want to do with your build before quitting the configurator?"), _this.s("closeDialog.savedMsg", "Would you like to get an official quote for this build before leaving?"), function () { _this.props.closeApp(); }, function () { utils_1.ZLTagger.UC07_finished(_this.props.buildSession.getSummary(), "close + quote"); });
        };
        _this.changePackage = function () {
            _this.showDialog(_this.s("changePackageDialog.unsavedMsg", "What do you want to do with your build before choosing another model?"), _this.s("changePackageDialog.savedMsg", "Would you like to get an official quote for this build before choosing another model?"), function () {
                utils_1.ZLTagger.UC04_changepackage();
                _this.props.buildSession.changePackage();
                if (_this.props.closeApp) {
                    _this.props.closeApp();
                }
            }, function () { utils_1.ZLTagger.UC07_finished(_this.props.buildSession.getSummary(), "change model + quote"); });
        };
        _this.showGallery = function (ev) {
            _this.setState({ showScreenshotGallery: true });
        };
        _this.takePhoto = function (ev) {
            actions_1.takePhoto(_this.props.modelName, libzl_1.captureConfig()).then(function (details) {
                _this.props.addScreenshot();
                var summary = {
                    action: "screenshot",
                    item: { name: "Successful" },
                    image: details === null || details === void 0 ? void 0 : details.imageURL,
                    imageAspect: details === null || details === void 0 ? void 0 : details.imageAspect,
                    onClick: _this.showGallery
                };
                console.log(summary);
                _this.props.addToast(summary);
            }, function () {
                var summary = {
                    action: "screenshot",
                    item: { name: 'Unsuccessful' }
                };
                _this.props.addToast(summary);
            });
        };
        _this.startShare = function () {
            _this.setState({ showShareDialog: true });
        };
        _this.s = function (id, defaultStr, params) {
            return utils_1.formatMessage(_this.props.intl, { id: id, defaultMessage: defaultStr ? defaultStr : id }, params ? params : {});
        };
        _this.showEnvironmentSelect = function () {
            _this.setState({ showEnvironmentSelector: true, shownEnvironmentSelector: true });
        };
        _this.clickedPromotion = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.buildSession) return [3 /*break*/, 2];
                        utils_1.ZLTagger.UC07_finished(this.props.buildSession.getSummary(), "promotion");
                        return [4 /*yield*/, this.props.buildSession.promotion()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        actions_1.finalize();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            showEnvironmentSelector: false,
            shownEnvironmentSelector: false,
            showScreenshotGallery: false,
            showShareDialog: false,
            genericDialogParams: undefined
        };
        return _this;
    }
    Banner.prototype.componentDidMount = function () {
        var _this = this;
        ScreenshotManager_1.CountScreenshots().then(function (count) {
            _this.props.updateScreenshotCount(count);
        });
    };
    Banner.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var icons = this.props.theme.svgs;
        var headerStr = this.s("banner.header", "Customize Your {modelyear}", { modelyear: this.props.buildSession ? this.props.buildSession.getModelYear(false) : "" });
        var changeStr = this.s("banner.changevehicle", "Change Model");
        var ambienceStr = this.s("banner.ambience", "Environment");
        var snapshotStr = this.s("banner.snapshot", "Take Snapshot");
        var galleryStr = this.s("banner.viewgallery", "View Gallery");
        var saveStr = this.s("banner.save", "Save");
        var closeStr = this.s("banner.quitconfigurator", "Quit Configurator");
        var shareStr = this.s("banner.sharebuild", "Share");
        var optionsStr = this.s("banner.options", "Options");
        var promotionStr = this.s("banner.promotion", "Current Promotions");
        var environmentBadge = this.state.shownEnvironmentSelector ? 0 : "!"; //this.props.environments;
        var headerbuttons = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(components_1.Badge, { count: this.props.screenshots },
                    react_1.default.createElement(RestrictedIconButton, { name: snapshotStr, disabled: this.props.norenderservice && !this.props.screenshots, small: true, icon: icons.icon_camera, automationId: "photooptions", taggingOverride: "notag" },
                        react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_cam_capture, disabled: this.props.norenderservice, onClick: this.takePhoto, text: snapshotStr, automationId: "takephoto" }),
                        react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_gallery, count: this.props.screenshots, onClick: this.showGallery, text: galleryStr, automationId: "view_gallery" }))),
                react_1.default.createElement(components_1.Badge, { count: environmentBadge },
                    react_1.default.createElement(RestrictedIconButton, { disabled: this.props.norenderservice, name: ambienceStr, small: true, icon: icons.icon_environment, onClick: this.showEnvironmentSelect, automationId: "showenvironmentselect" })),
                window.zlurlparams.alternateView && window.zlurlparams.promotion &&
                    react_1.default.createElement(RestrictedIconButton, { disabled: this.props.norenderservice, small: true, icon: icons.icon_promotions, onClick: this.clickedPromotion, name: promotionStr, automationId: "promotion" }),
                !window.zlurlparams.nosharing &&
                    react_1.default.createElement(RestrictedIconButton, { disabled: this.props.norenderservice, name: shareStr, small: true, icon: icons.icon_share, onClick: function () { return _this.setState({ showShareDialog: true }); }, automationId: "sharebuild" }),
                (window.zlurlparams.alternateView && !window.zlurlparams.global) &&
                    react_1.default.createElement(RestrictedIconButton, { disabled: this.props.norenderservice, small: true, icon: icons.icon_save, onClick: this.props.doSave, text: saveStr, automationId: "savebuild" }))));
        var closeButton = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(CloseButton, { name: closeStr, samll: true, icon: icons.close_filled, onClick: this.showCloseDialog, automationId: "close" }))));
        var assetEnv = (_a = window.zlurlparams.localstream) !== null && _a !== void 0 ? _a : (((_c = (_b = window.zlbolt) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.connectionParameters) ? ((_f = (_e = (_d = window.zlbolt) === null || _d === void 0 ? void 0 : _d.options) === null || _e === void 0 ? void 0 : _e.connectionParameters) === null || _f === void 0 ? void 0 : _f.environment) + " - " + ((_j = (_h = (_g = window.zlbolt) === null || _g === void 0 ? void 0 : _g.options) === null || _h === void 0 ? void 0 : _h.connectionParameters) === null || _j === void 0 ? void 0 : _j.region) : "pending");
        var websiteEnv = window.location.hostname;
        var apiEnv = (_k = window.zlurlparams.apidatasource) !== null && _k !== void 0 ? _k : "built-in";
        var locale = window.zlurlparams.locale;
        var optimised = ((_l = this.props.buildSession) === null || _l === void 0 ? void 0 : _l.getOptimisationLevel()) > 0 ? "- optimised" : "";
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(StyledHeader, { role: "banner" },
                window.zlurlparams.debug &&
                    react_1.default.createElement("div", { style: { position: 'fixed', top: 5, left: 0, right: 0, textAlign: 'center', fontSize: 10 } },
                        "Asset Environment: ",
                        assetEnv,
                        " --- Website Environment: ",
                        websiteEnv,
                        " --- API Environment: ",
                        apiEnv,
                        " - ",
                        locale,
                        " ",
                        optimised),
                react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 50 } },
                    react_1.default.createElement(NameWrapper, null,
                        react_1.default.createElement(Nameplate, { bodyText: this.props.modelName, headText: (window.zlurlparams.debug && this.props.buildSession) ? this.props.buildSession.getModelSku() : headerStr }),
                        (((_m = this.props.buildSession) === null || _m === void 0 ? void 0 : _m.getModelSku()) && !window.zlurlparams.global) &&
                            react_1.default.createElement(Swapbutton, { text: changeStr, onClick: this.changePackage, automationId: "changepackage" })),
                    react_1.default.createElement(HeaderButts, null,
                        react_1.default.createElement(IconHolder, null, headerbuttons),
                        react_1.default.createElement(CloseHolder, null, closeButton)),
                    react_1.default.createElement(MobileToggle, null,
                        react_1.default.createElement("div", { style: { position: "relative" } },
                            react_1.default.createElement(RoundButton, { name: optionsStr, icon: icons.actions_dots, automationId: "showoptions", taggingOverride: "notag" },
                                react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_camera, disabled: this.props.norenderservice, onClick: this.takePhoto, text: snapshotStr, automationId: "clicky2" }),
                                react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_gallery, count: this.props.screenshots, onClick: function () { _this.setState({ showScreenshotGallery: true }); }, text: galleryStr, automationId: "view_gallery" }),
                                react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_environment, disabled: !this.props.environments, count: environmentBadge, onClick: this.showEnvironmentSelect, text: ambienceStr, automationId: "showenvironmentselect" }),
                                window.zlurlparams.alternateView && window.zlurlparams.promotion &&
                                    react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_promotions, onClick: this.clickedPromotion, text: promotionStr, automationId: "promotionmobile" }),
                                !window.zlurlparams.nosharing &&
                                    react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_share, onClick: function () { return _this.setState({ showShareDialog: true }); }, text: shareStr, automationId: "sharebuild" }),
                                !window.zlurlparams.global &&
                                    react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_save, onClick: this.props.doSave, text: saveStr, automationId: "savebuildmobile" }),
                                !window.zlurlparams.global &&
                                    react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_change_model, onClick: this.changePackage, text: changeStr, automationid: "changepackage" }),
                                react_1.default.createElement(components_1.ContextOption, { icon: icons.icon_exit, onClick: this.showCloseDialog, text: closeStr, automationId: "close" })))))),
            this.state.showEnvironmentSelector &&
                react_1.default.createElement(EnvironmentSelect_1.default, { onClose: function () { return _this.setState({ showEnvironmentSelector: false }); } }),
            this.state.showScreenshotGallery &&
                react_1.default.createElement(Gallery_1.default, { onClose: function () { return _this.setState({ showScreenshotGallery: false }); } }),
            this.state.genericDialogParams &&
                react_1.default.createElement(GenericDialog_1.default, __assign({}, this.state.genericDialogParams)),
            this.state.showShareDialog &&
                react_1.default.createElement(ShareDialog_1.default, { onClose: function () { return _this.setState({ showShareDialog: false }); } })));
    };
    return Banner;
}(react_1.Component));
var MapStoreToProps = function (store /*, ownProps:any*/) {
    var buildSession = store.BuildSession.current;
    return {
        modelName: buildSession === null || buildSession === void 0 ? void 0 : buildSession.getMarketingName(),
        environments: (store.UI.environments.available || []).length,
        buildSession: buildSession,
        screenshots: store.UI.screenshots
    };
};
var UpdateScreenshotCount = function (count) { return ({
    type: ActionTypes_1.SET_SCREENSHOT_COUNT,
    data: count
}); };
var AddScreenshot = function () { return ({
    type: ActionTypes_1.ADD_SCREENSHOT
}); };
var AddToast = function (summary) { return ({
    type: ActionTypes_1.ADD_TOAST,
    summary: summary
}); };
exports.default = react_redux_1.connect(MapStoreToProps, {
    updateScreenshotCount: UpdateScreenshotCount,
    addScreenshot: AddScreenshot,
    addToast: AddToast,
})(styled_components_1.withTheme(react_intl_1.injectIntl(Banner)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
//# sourceMappingURL=Banner.js.map